<template>
<div>
  <lp-sort-drop-down :data="selected.sido" type="sido" placeholder="시/도" @onSelectItem="selSido" :list="sido"
                      width="120" style="display:inline-block;"></lp-sort-drop-down>
  <lp-sort-drop-down :data="selected.sigungu" type="sigungu" placeholder="시/군/구" @onSelectItem="selSigungu" :list="sigungu"
                      width="120" style="display:inline-block; margin-left:5px;"></lp-sort-drop-down>
  <lp-sort-drop-down :data="selected.dong" type="dong" placeholder="읍/면/동" @onSelectItem="selDong" :list="dong"
                      width="120" style="display:inline-block; margin-left:5px;"></lp-sort-drop-down>
</div>
</template>

<script>
import LpSortDropDown from './LpSortDropDown'

export default {
  components: {
    LpSortDropDown
  },
  props: ['data'],
  data() {
    return {
      sido: [],
      sigungu: [],
      dong: [],
      selected: {
        sido: '',
        sido_id:'',
        sigungu: '',
        sigungu_id:'',
        dong: '',
        dong_id:''
      }
    }
  },
  watch: {
    data(n) {
      this.selected = this.data;
    },
    'selected.sido_id'(n) {
      if (n)
      this.$axios.get('public/address/basic/sido/'+n+'/sigungu').then(res=>{
        if(res.status===200){
          this.sigungu = res.data;
        }
      })
    },
    'selected.sigungu_id'(n) {
      if (n)
      this.$axios.get('public/address/basic/sido/'+this.selected.sido_id+'/sigungu/'+n+'/dong').then(res=>{
        if(res.status===200){
          this.dong = res.data;
        }
      })
    },
  },
  created() {
    if(this.data && this.data.sido_id) this.selected = this.data;

    this.$axios.get('public/address/basic/sido').then(res=>{
      if(res.status===200){
        this.sido = res.data;
      }
    })
  },
  methods: {
    selSido(res) {
      this.selected.sido_id = res.value;
      this.selected.sido = res.label;
      this.selected.sigungu = '';
      this.selected.sigungu_id = '';
      this.selected.dong = '';
      this.selected.dong_id = '';
      this.$emit('update:data', this.selected);
    },
    selSigungu(res) {
      // 동읍면 불러오기
      this.selected.sigungu_id = res.value;
      this.selected.sigungu = res.label;
      this.selected.dong = '';
      this.selected.dong_id = '';
      this.$emit('update:data', this.selected);
    },
    selDong(res) {
      this.selected.dong_id = res.value;
      this.selected.dong = res.label;
      this.$emit('update:data', this.selected);
    }
  }
}
</script>

<style>

</style>
